import { Badge, Button, Dialog, DialogClose, ListTable, MobileCard, Plate, TextField, useToast, type ListColumn } from "@wilco/ui";
import { formatNumber, t } from "../i18n.ts";

/*
 * Витрина компонентов Д2 для ревью владельцем и скриншотов Playwright.
 * Данные выдуманные; длинное название проверяет перенос («3»).
 */
interface StockRow {
  id: string;
  product: string;
  shelf: string;
  onHand: number;
  reserved: number;
}

const ROWS: StockRow[] = [
  { id: "1", product: "Антена монопольна (симетрична) LAY-0001 з кабелем 1,5 м і роз'ємом SMA", shelf: "A-2-03", onHand: 1500, reserved: 320 },
  { id: "2", product: "Двигун Brother Hobby 4215 - 38", shelf: "B-1-01", onHand: 24, reserved: 24 },
  { id: "3", product: "Плата керування CH-01", shelf: "C-4-12", onHand: 7, reserved: 0 },
];

const COLUMNS: ListColumn<StockRow>[] = [
  { key: "product", header: t("ui.list.product"), kind: "title", render: (r) => r.product },
  { key: "shelf", header: t("ui.list.shelf"), kind: "text", width: "7rem", render: (r) => r.shelf },
  { key: "onHand", header: t("ui.list.onHand"), kind: "number", render: (r) => t("ui.qty", { qty: formatNumber(r.onHand) }) },
  { key: "reserved", header: t("ui.list.reserved"), kind: "number", render: (r) => t("ui.qty", { qty: formatNumber(r.reserved) }) },
];

export function UiKitPage() {
  const toast = useToast();
  return (
    <div className="page kit">
      <h1 className="page-title">{t("ui.title")}</h1>

      <section className="kit-section">
        <h2 className="desk-group-title">{t("ui.buttons")}</h2>
        <div className="kit-row">
          <Button variant="primary">{t("ui.button.primary")}</Button>
          <Button>{t("ui.button.secondary")}</Button>
          <Button variant="create">{t("ui.button.create")}</Button>
          <Button variant="ghost">{t("ui.button.ghost")}</Button>
          <Button variant="primary" disabled>
            {t("ui.button.primary")}
          </Button>
        </div>
      </section>

      <section className="kit-section">
        <h2 className="desk-group-title">{t("ui.badges")}</h2>
        <div className="kit-row">
          <Badge>{t("ui.badge.draft")}</Badge>
          <Badge tone="strong">{t("ui.badge.waiting")}</Badge>
          <Badge tone="success">{t("ui.badge.done")}</Badge>
          <Badge tone="danger">{t("ui.badge.late")}</Badge>
        </div>
      </section>

      <section className="kit-section">
        <h2 className="desk-group-title">{t("ui.fields")}</h2>
        <Plate cut="lg" className="kit-form">
          <TextField label={t("ui.field.qty")} hint={t("ui.field.qty.hint")} inputMode="numeric" defaultValue="12" />
          <TextField label={t("ui.field.serial")} variant="scan" defaultValue="CH-01-00005" error={t("ui.field.serial.error")} />
        </Plate>
      </section>

      <section className="kit-section">
        <h2 className="desk-group-title">{t("ui.plates")}</h2>
        <div className="kit-plates">
          <Plate>{t("ui.plate.text")}</Plate>
          <Plate cut="md" bordered>
            {t("ui.plate.bordered")}
          </Plate>
        </div>
      </section>

      <section className="kit-section">
        <h2 className="desk-group-title">{t("ui.list")}</h2>
        <ListTable label={t("ui.list.label")} columns={COLUMNS} rows={ROWS} rowKey={(r) => r.id} onRowClick={() => undefined} />
      </section>

      <section className="kit-section">
        <h2 className="desk-group-title">{t("ui.cards")}</h2>
        <div className="kit-cards">
          {ROWS.map((r) => (
            <MobileCard
              key={r.id}
              title={r.product}
              meta={<span className="w-num">{r.shelf}</span>}
              value={t("ui.qty", { qty: formatNumber(r.onHand) })}
              badge={r.reserved === r.onHand ? <Badge tone="strong">{t("ui.list.reserved")}</Badge> : undefined}
            />
          ))}
        </div>
      </section>

      <section className="kit-section">
        <h2 className="desk-group-title">{t("ui.dialog")} · {t("ui.toasts")}</h2>
        <div className="kit-row">
          <Dialog
            trigger={<Button>{t("ui.dialog.open")}</Button>}
            title={t("ui.dialog.title")}
            description={t("ui.dialog.text")}
            footer={
              <>
                <Button variant="primary">{t("ui.button.primary")}</Button>
                <Button>{t("ui.dialog.print")}</Button>
                <DialogClose asChild>
                  <Button variant="ghost">{t("ui.button.ghost")}</Button>
                </DialogClose>
              </>
            }
          />
          <Button onClick={() => toast({ title: t("ui.toast.success.title"), description: "A-2-03", tone: "success" })}>
            {t("ui.toast.success")}
          </Button>
          <Button onClick={() => toast({ title: t("ui.toast.danger.title"), description: "XX-404", tone: "danger" })}>
            {t("ui.toast.danger")}
          </Button>
        </div>
      </section>
    </div>
  );
}
